export const chapter4Translations = {
  name: "第4章：钉十字架与复活",
  description: "跟随耶稣受难、死亡和复活的故事",
  spiritualWisdom: "十字架是爱的最终胜利和战胜罪恶的象征。复活为我们提供了在基督里新生命的应许。",
  
  levels: {
    40: {
      name: "被捕",
      challenge: "了解耶稣在客西马尼园被捕的故事",
      
      questions: {
        easy: {
          question: "耶稣在哪个园子被捕？",
          options: ["客西马尼", "伊甸", "橄榄", "拿撒勒"],
          correctAnswer: 0,
          difficulty: "easy"
        },
        medium: {
          question: "犹大用什么信号出卖耶稣？",
          options: ["握手", "亲吻", "话语", "手势"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "哪个门徒用剑削掉了大祭司仆人的耳朵？",
          options: ["雅各", "约翰", "彼得", "安德烈"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "客西马尼是橄榄山脚下的一个园子",
        "犹大以三十块银钱出卖了耶稣",
        "耶稣奇迹般地治愈了仆人的耳朵"
      ],
      
      funFacts: [
        "客西马尼意为'榨油处'，是制作橄榄油的地方",
        "耶稣的被捕发生在深夜",
        "耶稣平静地前去，要求门徒不要用暴力抵抗"
      ]
    },

    41: {
      name: "彼得的否认",
      challenge: "了解彼得三次否认耶稣的故事",
      
      questions: {
        easy: {
          question: "彼得否认耶稣几次？",
          options: ["一次", "两次", "三次", "四次"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "彼得第三次否认后发生了什么？",
          options: ["太阳升起", "鸡叫了", "闪电闪烁", "地震发生"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "彼得在哪里否认耶稣？",
          options: ["在圣殿", "在大祭司的院子里", "在彼拉多的宫殿", "在客西马尼"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "耶稣预言了彼得的否认",
        "彼得意识到自己所做的事后痛哭",
        "一切都发生在同一个晚上"
      ],
      
      funFacts: [
        "耶稣说'鸡叫以前，你要三次不认我'",
        "彼得的否认是人性软弱和神圣宽恕的有力例证",
        "彼得后来成为教会的伟大领袖"
      ]
    },

    42: {
      name: "耶稣在彼拉多面前",
      challenge: "了解耶稣在罗马总督面前受审的故事",
      
      questions: {
        easy: {
          question: "彼拉多是谁？",
          options: ["门徒", "罗马总督", "大祭司", "法利赛人"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "彼拉多在耶稣身上没有找到什么？",
          options: ["智慧", "罪状", "勇气", "能力"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "彼拉多做了什么来象征自己的清白？",
          options: ["洗手", "撕裂衣服", "禁食", "祷告"],
          correctAnswer: 0,
          difficulty: "hard"
        }
      },
      
      hints: [
        "彼拉多想释放耶稣",
        "众人要求将耶稣钉十字架",
        "彼拉多屈服于政治压力"
      ],
      
      funFacts: [
        "彼拉多的妻子警告他不要对耶稣做任何事",
        "洗手在犹太传统中是清白的象征",
        "彼拉多的决定显示了人类正义的失败"
      ]
    },

    43: {
      name: "巴拉巴还是耶稣",
      challenge: "了解众人选择巴拉巴的故事",
      
      questions: {
        easy: {
          question: "巴拉巴是什么人？",
          options: ["门徒", "强盗", "祭司", "国王"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "在犹太节期期间，彼拉多可以做什么？",
          options: ["释放一个囚犯", "免除税收", "提供宴席", "关闭圣殿"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "众人选择了谁？",
          options: ["耶稣", "巴拉巴", "两个都选", "谁都不选"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "这是逾越节期间",
        "众人要求将耶稣钉十字架",
        "巴拉巴是个杀人犯和叛乱分子"
      ],
      
      funFacts: [
        "巴拉巴这个名字意为'父亲的儿子'",
        "巴拉巴的释放象征着基督的牺牲",
        "我们都是巴拉巴，被耶稣的牺牲所释放"
      ]
    },

    44: {
      name: "鞭打和荆棘冠冕",
      challenge: "了解耶稣的受难",
      
      questions: {
        easy: {
          question: "士兵们把什么戴在耶稣头上？",
          options: ["金冠", "荆棘冠冕", "花环", "头巾"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "士兵们如何嘲笑耶稣？",
          options: ["称他为王", "向他扔石头", "把他关进监狱", "无视他"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "罗马鞭子里有什么？",
          options: ["皮条", "骨头和金属碎片", "只有木头", "绳子"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "鞭打是残酷的罗马刑罚",
        "士兵们给耶稣穿上紫袍",
        "耶稣默默地忍受了这一切"
      ],
      
      funFacts: [
        "荆棘冠冕象征着罪的咒诅",
        "紫色是王室的颜色，被用作嘲弄",
        "耶稣的受难应验了以赛亚的预言"
      ]
    },

    45: {
      name: "前往各各他之路",
      challenge: "了解耶稣背十字架的故事",
      
      questions: {
        easy: {
          question: "耶稣背的是什么？",
          options: ["旗帜", "十字架", "冠冕", "剑"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "谁帮助耶稣背十字架？",
          options: ["彼得", "约翰", "古利奈人西门", "约瑟"],
          correctAnswer: 2,
          difficulty: "medium"
        },
        hard: {
          question: "各各他是什么意思？",
          options: ["圣山", "髑髅地", "和平之地", "公义之地"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "耶稣因虚弱而跌倒",
        "妇女们在路上哭泣",
        "队伍穿过城市"
      ],
      
      funFacts: [
        "十字架重约40-50公斤",
        "各各他在城墙外面",
        "古利奈人西门来自非洲"
      ]
    },

    46: {
      name: "钉十字架",
      challenge: "了解耶稣被钉十字架的故事",
      
      questions: {
        easy: {
          question: "耶稣和其他几个人一起被钉十字架？",
          options: ["没有", "一个", "两个", "三个"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "耶稣在十字架上说了什么：'父啊，___他们'？",
          options: ["拯救", "赦免", "阻止", "惩罚"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "十字架上的牌子写的是什么？",
          options: ["罪人", "犹太人的王", "叛徒", "先知"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "耶稣在白天第三时辰被钉十字架",
        "士兵们抽签分他的衣服",
        "耶稣在十字架上说了七句话"
      ],
      
      funFacts: [
        "牌子用三种语言写成：希伯来文、拉丁文和希腊文",
        "一个强盗在最后时刻悔改",
        "耶稣把他的母亲托付给约翰照顾"
      ]
    },

    47: {
      name: "耶稣之死",
      challenge: "了解耶稣最后的时刻",
      
      questions: {
        easy: {
          question: "耶稣死的时候发生了什么？",
          options: ["太阳更亮了", "黑暗降临", "下雨了", "出现彩虹"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "圣殿里什么东西裂开了？",
          options: ["地板", "幔子", "墙", "天花板"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "耶稣最后的话是什么？",
          options: ["成了", "我渴了", "父啊，我将我的灵魂交在你手里", "为什么离弃我"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "黑暗持续了三小时",
        "一个士兵用枪刺了耶稣的肋旁",
        "百夫长说'这真是神的儿子'"
      ],
      
      funFacts: [
        "圣殿的幔子从上到下裂开，不是人手所为",
        "这发生在逾越节期间，正是献羔羊的时候",
        "耶稣的死付清了罪的代价"
      ]
    },

    48: {
      name: "安葬",
      challenge: "了解耶稣的安葬",
      
      questions: {
        easy: {
          question: "耶稣被放在谁的坟墓里？",
          options: ["彼得", "亚利马太的约瑟", "尼哥底母", "拉撒路"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "耶稣的身体用什么包裹？",
          options: ["紫袍", "金色衣服", "白色细麻布", "没有衣服"],
          correctAnswer: 2,
          difficulty: "medium"
        },
        hard: {
          question: "尼哥底母为耶稣的身体带来了什么？",
          options: ["油", "没药和沉香", "水", "花"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "坟墓是凿在新的磐石中",
        "一块大石头滚到入口处",
        "守卫被安排看守坟墓"
      ],
      
      funFacts: [
        "这是一个财主的坟墓，应验了以赛亚的预言",
        "安葬很匆忙，因为安息日快到了",
        "约瑟是个暗中的门徒，后来变得勇敢"
      ]
    },

    49: {
      name: "空坟墓",
      challenge: "了解复活清晨的发现",
      
      questions: {
        easy: {
          question: "谁最先发现坟墓是空的？",
          options: ["彼得", "约翰", "妇女们", "士兵们"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "石头在哪里？",
          options: ["破碎了", "滚开了", "还在那里", "消失了"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "妇女们在坟墓里遇见了几个天使？",
          options: ["没有", "一个", "两个", "三个"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "这是七日的第一日清晨",
        "妇女们来为耶稣的身体抹香膏",
        "天使们宣告了好消息"
      ],
      
      funFacts: [
        "妇女们是第一批见证人，这是个革命性的细节",
        "彼得和约翰跑到坟墓",
        "单凭空坟墓还不够，耶稣需要显现"
      ]
    },

    50: {
      name: "耶稣向抹大拉的马利亚显现",
      challenge: "了解耶稣的第一次显现",
      
      questions: {
        easy: {
          question: "复活后耶稣首先向谁显现？",
          options: ["彼得", "约翰", "抹大拉的马利亚", "多马"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "马利亚起初把耶稣当作谁？",
          options: ["天使", "园丁", "士兵", "法利赛人"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "当马利亚认出耶稣时，耶稣对她说了什么？",
          options: ["去告诉他们", "不要摸我", "不要怕", "相信"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "马利亚在坟墓旁哭泣",
        "耶稣叫她的名字",
        "他差遣她去告诉他的弟兄们"
      ],
      
      funFacts: [
        "耶稣选择一位妇女作为他第一次显现的对象",
        "马利亚成为第一位使徒",
        "她称他为'拉波尼'（老师）"
      ]
    },

    51: {
      name: "在以马忤斯的路上",
      challenge: "了解耶稣在路上的显现",
      
      questions: {
        easy: {
          question: "有几个门徒去以马忤斯？",
          options: ["一个", "两个", "三个", "四个"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "门徒们什么时候认出耶稣？",
          options: ["立刻", "掰饼的时候", "在路上", "从未认出"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "耶稣在路上给他们讲解了什么？",
          options: ["未来", "圣经", "律法", "神迹"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "耶稣作为陌生人与他们同行",
        "他说话时，他们的心里火热",
        "当他们认出他时，耶稣就不见了"
      ],
      
      funFacts: [
        "以马忤斯距离耶路撒冷约11公里",
        "耶稣向他们显明所有圣经是如何指向他的",
        "门徒们立刻跑回耶路撒冷"
      ]
    },

    52: {
      name: "向门徒显现",
      challenge: "了解耶稣在关闭的房间里的显现",
      
      questions: {
        easy: {
          question: "耶稣显现时门徒们在哪里？",
          options: ["在圣殿", "在市场", "在关闭的房间里", "在客西马尼"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "耶稣向门徒们显示了什么？",
          options: ["他的伤痕", "他的脸", "他的衣服", "一道光"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "第一次哪个门徒不在场？",
          options: ["彼得", "约翰", "多马", "雅各"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "门关着是因为怕犹太人",
        "耶稣说'愿你们平安'",
        "他向他们吹气说'你们受圣灵'"
      ],
      
      funFacts: [
        "耶稣与他们一起吃饭，证明他不是鬼魂",
        "多马一周后相信了",
        "耶稣在40天内多次显现"
      ]
    }
  }
};
